"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChatUnread = void 0;
const react_1 = __importDefault(require("react"));
const stream_chat_react_1 = require("stream-chat-react");
const set_unread_messages_1 = require("@app/ac/set-unread-messages");
const store_1 = require("@app/store");
const is_defined_1 = require("../../is-defined");
const useChatOnClientLoad_1 = require("./useChatOnClientLoad");
const useChatUnread = () => {
    const dispatch = (0, store_1.useRootDispatch)();
    const me = (0, store_1.useRootSelector)((state) => state.me);
    const unread = (0, store_1.useRootSelector)((state) => state.chat.unread);
    const { client } = (0, stream_chat_react_1.useChatContext)();
    (0, useChatOnClientLoad_1.useChatOnClientLoad)((_client) => {
        _client.getUnreadCount(_client.userID).then(async (unreadCount) => {
            await dispatch((0, set_unread_messages_1.setUnreadMessages)(unreadCount.total_unread_count));
        }).catch(console.error);
    });
    react_1.default.useEffect(() => {
        const handleEvent = async (event) => {
            if ((0, is_defined_1.isUndefined)(event.total_unread_count))
                return;
            await dispatch((0, set_unread_messages_1.setUnreadMessages)(event.total_unread_count));
        };
        client.on('message.new', handleEvent);
        return () => {
            client.off('message.new', handleEvent);
        };
    }, [me, client]);
    return unread;
};
exports.useChatUnread = useChatUnread;
